<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Administrator</ng-container>
  <ng-container *ngIf="data.id">Edit Administrator</ng-container>
</h1>
<mat-dialog-content>

  <aw-admin-form [admin]="data" (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"></aw-admin-form>

</mat-dialog-content>